"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLDraggable = void 0;
const react_1 = require("react");
const OLDragProvider_1 = require("./OLDragProvider");
function useOLDraggable(isDraggable, feature) {
    const { draggableFeatures } = react_1.useContext(OLDragProvider_1.OLDragContext);
    react_1.useEffect(() => {
        if (isDraggable) {
            draggableFeatures.push(feature);
            return () => {
                draggableFeatures.remove(feature);
            };
        }
        else {
            return () => { };
        }
    }, [draggableFeatures, feature, isDraggable]);
}
exports.useOLDraggable = useOLDraggable;
//# sourceMappingURL=useOLDraggable.js.map